import React from 'react';
import { BRAND_NAME, INSTAGRAM_HANDLE, INSTAGRAM_LINK, SUPPORT_EMAIL, WHATSAPP_LINK } from './Shared';
export function Footer() {
  return <>
      <section className="border-t-2 border-brand-gold/50 bg-brand-parchment py-12" aria-labelledby="ps-title" data-id="element-104" data-mp="3ghc323c0v5or">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-105" data-mp="32m1ch24t96q7">
          <h2 id="ps-title" className="font-serif text-xl font-bold text-brand-taupe" data-id="element-106" data-mp="36pzaf9iegbho">
            P.D.: Si tenés dudas, escribinos.
          </h2>
          <ul className="mt-4 space-y-2 text-sm text-brand-textLight md:text-base" data-id="element-107" data-mp="38h5b9u0hiky">
            <li data-id="element-108" data-mp="36czunggsbik">
              📧 <strong className="text-brand-taupe" data-id="element-109" data-mp="3levgx24t5gg6">Email:</strong>{' '}
              <a className="font-semibold text-brand-goldDark hover:underline" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-110" data-mp="3lgooqkr5q6pr">
                {SUPPORT_EMAIL}
              </a>
            </li>
            <li data-id="element-111" data-mp="29xvpe8qab5n7">
              📲 <strong className="text-brand-taupe" data-id="element-112" data-mp="2a1jjpa3jzw2z">Instagram:</strong>{' '}
              <a className="font-semibold text-brand-goldDark hover:underline" href={INSTAGRAM_LINK} data-id="element-113" data-mp="2ezl3jx8szzfi">
                {INSTAGRAM_HANDLE}
              </a>
            </li>
            <li data-id="element-114" data-mp="3gbinuv867u3e">
              💬 <strong className="text-brand-taupe" data-id="element-115" data-mp="3gc0hdk3g7u7m">WhatsApp:</strong>{' '}
              <a className="font-semibold text-brand-goldDark hover:underline" href={WHATSAPP_LINK} data-id="element-116" data-mp="3v7zuxa9bumk5">
                Escribinos ahora
              </a>
            </li>
          </ul>
          <p className="mt-5 text-sm italic text-brand-muted" data-id="element-117" data-mp="82idvwen2ggf">
            Te respondemos hoy. Sin demoras. Sin automatizaciones.
          </p>
        </div>
      </section>

      <footer className="bg-brand-text py-12 text-center font-sans text-white" data-id="element-118" data-mp="3230x5y9rayz">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-119" data-mp="hs21ffdaqyhm">
          <p className="mb-3 font-serif text-2xl font-bold text-brand-gold md:text-3xl" data-id="element-120" data-mp="cus29803v8gl">🌿 {BRAND_NAME}™</p>
          <p className="text-sm text-white/85 md:text-base" data-id="element-121" data-mp="qub9lyl3efru">
            El sistema definitivo de Cosmética Natural como Negocio de Vida.
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 text-sm md:flex-row md:gap-7" data-id="element-122" data-mp="tv4iroyaqfyo">
            <a className="transition-colors duration-150 ease-out hover:text-brand-gold" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-123" data-mp="yto9e2nu4fxd">
              📧 {SUPPORT_EMAIL}
            </a>
            <a className="transition-colors duration-150 ease-out hover:text-brand-gold" href={INSTAGRAM_LINK} data-id="element-124" data-mp="13rg0iugnny0i">
              📲 {INSTAGRAM_HANDLE}
            </a>
          </div>

          <div className="mt-10 space-y-2 border-t border-white/20 pt-6 text-xs text-white/55" data-id="element-125" data-mp="1clclw71zx6ev">
            <p data-id="element-126" data-mp="1hiukb3ie038m">© Visión Digital™ 2025 — Todos los derechos reservados.</p>
            <p data-id="element-127" data-mp="1mktpmixota87">Prohibida la reproducción y redistribución sin autorización expresa.</p>
            <p data-id="element-128" data-mp="1rj508vvt3orh">Ley 25.326 — Protección de Datos Personales — República Argentina</p>
            <p data-id="element-129" data-mp="3obomle3mrfgi">Ley 11.723 — Propiedad Intelectual — República Argentina</p>
          </div>
        </div>
      </footer>
    </>;
}